














import Vue from "vue";

export default Vue.extend({
  props: {
    /** text type */
    type: {
      type: String,
      default: "text",
    },
    label: String,
    maxlength: Number,
    min: Number,
    max: Number,
    readonly: Boolean,
  },
  model: {
    event: "input",
  },
  methods: {
    handleInput(e: any) {
      const { $refs, type, min, max } = this;

      let { input } = $refs;
      let { value } = e.target;

      if (type === "number") {
        value = Number(value);

        if (!isNaN(min)) {
          if (Number(min) > value) {
            value = min;

            // NOTE: inputに表示される値に変更が反映されないので直接Elementの値を変更する
            (input as HTMLInputElement).value = min.toString();
          }
        }

        if (!isNaN(max)) {
          if (Number(max) < value) {
            value = max;

            // NOTE: inputに表示される値に変更が反映されないので直接Elementの値を変更する
            (input as HTMLInputElement).value = max.toString();
          }
        }

        value = value.toString();
      }

      this.$emit("input", value);
    },
  },
});
